import { Button } from '@mui/material';
import { ICommonButtonProps } from '../../types/button';

export const CommonButton = ({ onClick, label }: ICommonButtonProps) => {
  return (
    <Button
      variant="contained"
      sx={{ fontSize: 12, fontWeight: 600, flexShrink: 0 }}
      onClick={() => {
        onClick();
      }}
    >
      {label}
    </Button>
  );
};
